export const BYTES = 1024
export const KILOBYTES = 1024
export const MAX_FILES_SIZE_MB = 35
export const MAX_FILES_SIZE_MB_LOGO = 30
export const MAX_FILES_SIZE = MAX_FILES_SIZE_MB * BYTES * KILOBYTES
export const MAX_FILES_SIZE_LOGO = MAX_FILES_SIZE_MB_LOGO * BYTES * KILOBYTES
export const LOGO_WIDTH = 100
export const LOGO_HEIGHT = 40
